import DcePlugin from "../../../../dce-engine/lib/plugins/decorators/DcePlugin";
import DcePluginBase from "../../../../dce-engine/lib/plugins/types/DcePluginBase";
import DceWireEventDetails from "./DceWireEventDetails";
import DceHtmlElementWithWireEvents from "./DceHTMLElementWithWireEvents";
import {DceEngine} from "../../../../dce-engine";

const WIRE_EVENTS = ['click', 'submit', 'change'];

@DcePlugin("fragments")
export default class DceFragmentsPlugin extends DcePluginBase{

    initializeBody(body: HTMLElement) {
        this.bindEvents([body]);
    }

    addedNodes(nodes: Node[]) {
        this.bindEvents(nodes);
    }

    private bindEvents(nodes: Node[]) {

        let ignoredElements = DceEngine.getInstance().getIgnoredElements();

        nodes.filter(n => {
            //usuwamy nie elementy
            if (n.nodeType != Node.ELEMENT_NODE) {
                return false;
            }

            //usuwamy te ktore nie sa ignorowane
            for (let i = 0; i < ignoredElements.length; i++) {
                if (ignoredElements[i].contains(n)) {
                    return false;
                }
            }

            return true;

        }).map(n => {
            return (n as HTMLElement);
        }).forEach(elem => {

            let welem = elem as DceHtmlElementWithWireEvents;

            for (const wireevent of WIRE_EVENTS) {

                if (elem.hasAttribute('data-wire-' + wireevent)) {
                    this.attachWireEvents(welem, wireevent);
                }

                elem.querySelectorAll('[data-wire-' + wireevent + ']').forEach(e => {
                    let we = e as DceHtmlElementWithWireEvents;
                    this.attachWireEvents(we, wireevent);
                });

            }

        });

    }

    private attachWireEvents(we: DceHtmlElementWithWireEvents, wireevent: string): void {

        console.log("ATT WIRE EVENT ", we);

        if (!we.wiresAdded) {
            console.log('new we')
            we.wiresAdded = [];
        }

        if (we.wiresAdded.indexOf(wireevent) < 0) {
            //nie dodano wireevent'a

            we.addEventListener(wireevent, event => {
                event.stopPropagation();

                let clickParam = we.getAttribute('data-wire-' + wireevent);
                event.preventDefault();

                we.dispatchEvent(
                    new CustomEvent<DceWireEventDetails>('dceWire', {
                        bubbles: true,
                        detail: {
                            type: wireevent,
                            originalEvent: event,
                            element: we,
                            attr: we.getAttribute('data-wire-' + wireevent)
                        }
                    }),
                );
            });

            //do not attach more than one
            we.wiresAdded.push(wireevent);

        }

    }
}